import React from 'react';

const AnnouncementBar = () => {
  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] bg-[#C9A227] overflow-hidden"
      data-testid="announcement-bar"
      style={{ height: '36px' }}
    >
      <div className="h-full flex items-center justify-center px-4">
        <div className="flex items-center gap-1.5 sm:gap-2 text-[#0a0a0a]">
          <span className="text-[10px] sm:text-xs font-bold tracking-wider uppercase">
            Launch Offer
          </span>
          <span className="text-[10px] sm:text-xs font-medium">|</span>
          <span className="text-[10px] sm:text-xs font-semibold tracking-wide">
            Flat 20% Off + Free Worldwide Shipping
          </span>
          <span className="text-[10px] sm:text-xs font-medium hidden sm:inline">|</span>
          <span className="hidden sm:inline text-[10px] sm:text-xs font-medium opacity-70">
            Use Code
          </span>
          <span className="text-[10px] sm:text-xs font-bold tracking-widest bg-[#0a0a0a] text-[#C9A227] px-1.5 py-0.5 rounded-sm">
            ZELINA20
          </span>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;
